import { render, staticRenderFns } from "./participant-types.vue?vue&type=template&id=1214c844&"
import script from "./participant-types.vue?vue&type=script&lang=js&"
export * from "./participant-types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports